import {
  durationOptionSchema,
  customDurationUnitSchema,
  durationDictionary,
  durationOptions,
  type IDurationOption,
  type ICustomDurationUnit,
  DEFAULT_ACTIVITY_DURATION_MINUTES,
} from "./activityDurationModels";

export const convertDurationToMinutes = (
  durationOption: IDurationOption,
  customDuration: string | null,
  customDurationUnit: ICustomDurationUnit | null,
): number => {
  const durationConfig = durationDictionary[durationOption];

  if (durationConfig.numberOfMinutes !== null) {
    return durationConfig.numberOfMinutes;
  }

  const durationValue = customDuration
    ? parseInt(customDuration, 10)
    : DEFAULT_ACTIVITY_DURATION_MINUTES;
  return customDurationUnit === customDurationUnitSchema.enum.hours
    ? durationValue * 60
    : durationValue;
};

export const convertMinutesToDurationFields = (
  minutes: number,
): {
  durationOption: IDurationOption;
  customDuration: string | null;
  customDurationUnit: ICustomDurationUnit | null;
} => {
  for (const key of durationOptions) {
    if (durationDictionary[key].numberOfMinutes === minutes) {
      return {
        durationOption: key,
        customDuration: null,
        customDurationUnit: null,
      };
    }
  }

  if (minutes % 60 === 0) {
    return {
      durationOption: durationOptionSchema.enum.custom,
      customDuration: String(minutes / 60),
      customDurationUnit: customDurationUnitSchema.enum.hours,
    };
  } else {
    return {
      durationOption: durationOptionSchema.enum.custom,
      customDuration: String(minutes),
      customDurationUnit: customDurationUnitSchema.enum.minutes,
    };
  }
};

export const formatDuration = (minutes: number) => {
  if (minutes % 60 === 0) {
    return {
      value: minutes / 60,
      timeUnit: "hour",
    };
  }
  return {
    value: minutes,
    timeUnit: "minute",
  };
};
